import { SYNC_ESPERIENZA } from '@package/actions/sync';

const initialState = {
  error: null,
  sync: {},
  loaded: false,
  loading: false,
};

export default function syncReducer(state = initialState, action) {
  switch (action.type) {
    case `${SYNC_ESPERIENZA}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    case `${SYNC_ESPERIENZA}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        sync: action.result ?? {},
      };
    case `${SYNC_ESPERIENZA}_FAIL`:
      return {
        ...state,
        error: action.error,
        loaded: false,
        loading: false,
      };
    default:
      return state;
  }
}
